import {makeKey,update} from '../../../../utils/reducerOperations';
export function fetchSurveyListStarted(state, payload) {
    return makeKey(
        'fetchSurveyApi',
        update(state.fetchSurveyApi, {
            isProcessing: true
        })
    );
}